import { API_ENDPOINT } from 'env'

const authHeaders = () => {
  const parsed = JSON.parse(localStorage.getItem('state'))
  return { 'Content-Type': 'application/json', Authorization: `Bearer ${parsed.auth.token}` }
}

const handle = async (res) => {
  if (!res.ok) {
    const error = await res.json().catch(() => ({}))
    throw new Error(error.message || 'Erro na requisição')
  }
  return res.json()
}

export const transferir = async (body) => {
  const res = await fetch(`${API_ENDPOINT}/operacoes-lbc/transferencia`, {
    method: 'post', headers: authHeaders(), body: JSON.stringify(body),
  })
  return handle(res)
}

export const getCadeia = async (tituloId) => {
  const res = await fetch(`${API_ENDPOINT}/titulos-lbc/${tituloId}/cadeia`, { method: 'GET', headers: authHeaders() })
  return handle(res)
}
